import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    useDisclosure,
    Button,
  } from '@chakra-ui/react';
  import { Input } from '@chakra-ui/react';
// import PaymentSummary from './PaymentSummary';
import {useNavigate} from "react-router-dom";
import './Address.css';
  

const Address = (props) => {
    const navigate = useNavigate();

    const OverlayOne = () => (
        <ModalOverlay
          bg='blackAlpha.300'
          backdropFilter='blur(10px) hue-rotate(90deg)'
        />
      )
    
      const { isOpen, onOpen, onClose } = useDisclosure()
      const [overlay, setOverlay] = React.useState(<OverlayOne />)

      const handleAddress=()=>{
        // console.log(props.amount);
        const amount=props.amount;
        navigate(`/payment?amount=${amount}`);
      }
  return (
    <div>
       
       
       <Button style={{backgroundColor: "#6e42e5", color:"white",width:"80%", marginTop:"20px"}}
        onClick={() => {
          setOverlay(<OverlayOne />)
          onOpen()
        }}
      >
        Add adddrress and slot
      </Button>
      <Modal className='ModalContent' isCentered isOpen={isOpen} onClose={onClose}>
        {overlay}
        <ModalContent >
          <ModalHeader style={{textAlign: "center"}}>ADDRESS</ModalHeader>
          <br />
          <Input style={{textAlign: "center"}} placeholder='State' />
          <br />
          <br />
          <Input style={{textAlign: "center"}} placeholder='City' />
          <br />
          <br />
          <Input style={{textAlign: "center"}} placeholder='Area' />
          <br />
          <br />
          <Input style={{textAlign: "center"}} placeholder='Building' />
          <br />
          <br />
          <Input style={{textAlign: "center"}} placeholder='House no' />
          <ModalCloseButton />
          <br />
          <Button colorScheme='blue' onClick={handleAddress}>Submit</Button>
          
        </ModalContent>
        
      </Modal>
     
      
      
    </div>
  )
}

export default Address
